// Full cart page (page-warenkorb.php): server-rendered lines, re-rendered from the server cart after every change.
import { subscribe, loadCart, removeItem, setQty, applyCoupon, removeCoupon, totals, holdCountdown, holdSecondsLeft } from './cart.js';
import { qs, qsa, tpl, on, t } from './dom.js';

export function initCartPage() {
  const root = qs('[data-cart-page]');
  if (!root) return;
  const list = qs('[data-cart-page-list]', root);
  const empty = qs('[data-cart-page-empty]', root);
  const filled = qs('[data-cart-page-filled]', root);
  const timer = qs('[data-page-timer]', root);
  let tick = null;

  function renderTimer(state) {
    if (!timer) return;
    const txt = holdCountdown(state);
    timer.hidden = !txt;
    if (txt) qs('[data-page-timer-text]', timer).textContent = t('woo.reserved_for', { time: txt });
    if (txt && holdSecondsLeft(state) === 0) loadCart(true);
  }

  function render(state) {
    const tot = totals(state);
    empty.hidden = tot.count > 0;
    filled.hidden = tot.count === 0;
    list.innerHTML = '';
    (state.items || []).forEach((item) => {
      const node = tpl('tpl-cart-line', {
        image: item.image, title: item.title, date: item.date_display, location: item.location,
        details: [item.name, item.seat].filter(Boolean).join(' · '), unit: item.fmt_unit, line: item.fmt_line, qty: String(item.qty),
      });
      node.dataset.key = item.key;
      const link = qs('[data-f="title"]', node);
      if (link && link.tagName === 'A' && item.url) link.href = item.url;
      const stepper = qs('[data-stepper]', node);
      const fixed = qs('[data-fixed-qty]', node);
      if (item.fixed_qty) { if (stepper) stepper.hidden = true; if (fixed) fixed.hidden = false; }
      else { if (stepper) stepper.hidden = false; if (fixed) fixed.hidden = true; }
      const minus = qs('[data-qty-minus]', node);
      if (minus) minus.disabled = item.qty <= 1;
      const plus = qs('[data-qty-plus]', node);
      if (plus) plus.disabled = item.qty >= 10;
      list.appendChild(node);
    });
    qs('[data-page-subtotal]', root).textContent = tot.fmt.subtotal;
    qs('[data-page-fee]', root).textContent = tot.fmt.fee;
    qs('[data-page-total]', root).textContent = tot.fmt.total;
    const coupon = tot.coupons[0] || null;
    qs('[data-page-discount-row]', root).hidden = !coupon;
    qs('[data-page-discount]', root).textContent = tot.fmt.discount;
    qs('[data-page-coupon-form]', root).hidden = !!coupon;
    qs('[data-page-coupon-applied]', root).hidden = !coupon;
    qs('[data-page-coupon-code]', root).textContent = coupon ? coupon.code : '';
    const sub = qs('[data-page-coupon-sub]', root);
    if (sub) sub.textContent = coupon ? coupon.fmt : '';
    const checkout = qs('[data-page-checkout]', root);
    if (checkout && state.checkout_url) checkout.href = state.checkout_url;
    const count = qs('[data-page-count]', root);
    if (count) count.textContent = tot.count === 1 ? t('cart.item') : t('cart.items', { n: tot.count });
    renderTimer(state);
    clearInterval(tick);
    if (tot.count > 0) tick = setInterval(() => renderTimer(state), 1000);
  }

  subscribe(render);
  loadCart(true);

  on(root, 'click', '[data-remove]', (e, btn) => {
    e.preventDefault();
    btn.disabled = true;
    removeItem(btn.closest('[data-key]').dataset.key);
  });
  on(root, 'click', '[data-qty-minus], [data-qty-plus]', (e, btn) => {
    e.preventDefault();
    const line = btn.closest('[data-key]');
    const cur = Number(qs('[data-f="qty"]', line).textContent || 1);
    const next = btn.hasAttribute('data-qty-plus') ? cur + 1 : cur - 1;
    qsa('button', line).forEach((b) => { b.disabled = true; });
    setQty(line.dataset.key, Math.max(0, Math.min(10, next)));
  });
  on(root, 'submit', '[data-page-coupon-form]', async (e, form) => {
    e.preventDefault();
    const btn = qs('button', form);
    if (btn) btn.disabled = true;
    const ok = await applyCoupon(form.code.value);
    if (btn) btn.disabled = false;
    if (ok) form.reset();
  });
  on(root, 'click', '[data-page-coupon-remove]', (e) => {
    e.preventDefault();
    removeCoupon(qs('[data-page-coupon-code]', root).textContent);
  });
}
